module.exports = __webpack_public_path__ + "static/media/category_placeholder.6664fd6e.png";